module.exports = __webpack_public_path__ + "img/light2.5a89aa58.png";